import React, { useEffect, useRef, useState } from "react"

import classNames from "gpages/utils/classnames"

import * as styles from "./nav.module.scss"
import logoImg from "@images/logo.png"
import { useScrollEvent } from "@src/utils/hooks/common"
import Clickable from "../clickable"
import Icon from "../icon"
import { useAppContext } from "@src/context/appContext"
import classnames from "gpages/utils/classnames"
import ApplyModal from "../applyModal"

const ITEMS = [
  {
    key: "home",
    title: "主页",
    to: "/",
  },
  {
    key: "games",
    title: "游戏列表",
    to: "/games",
  },
  {
    key: "news",
    title: "最新资讯",
    to: "https://www.gcores.com/organizations/63175/originals",
  },
  {
    key: "about",
    title: "关于发行",
    to: "https://site.gcores.com/publishing_intro/",
  },
  {
    key: "apply",
    title: "申请发行",
    icon: "outlink",
    hideSm: true,
    highlight: true,
  },
]

const Nav = ({ location }) => {
  const [applyModalVisible, setApplyModalVisible] = useState(false)
  const { isAppLayout } = useAppContext()
  const [dropdownVisble, setDropdownVisible] = useState(false)
  const [visible, setVisible] = useState(true)
  const prevScrollTopRef = useRef()
  const [currentPathname, setCurrentPathname] = useState()

  useEffect(() => {
    setCurrentPathname(location?.pathname)
  }, [location?.pathname])

  useScrollEvent(() => {
    const scrollTop = window.scrollY
    const prevTop = prevScrollTopRef.current
    if (scrollTop <= 500) {
      setVisible(true)
      return
    }
    if (prevTop >= 0) {
      setVisible(scrollTop < prevTop)
    }
    prevScrollTopRef.current = scrollTop
  })

  return (
    <nav
      id="nav"
      className={classNames(styles.nav, {
        [styles.isDropdown]: dropdownVisble,
        [styles.isHide]: !visible,
      })}
    >
      <Clickable
        className={styles.dropDownMask}
        onClick={() => {
          setDropdownVisible(false)
        }}
      />
      <div>
        <div className={styles.logoContainer}>
          <img src={logoImg} className={styles.logo} alt="logo" />
        </div>
        <div className={styles.right}>
          <Clickable
            className={styles.menuBtn}
            onClick={() => {
              setDropdownVisible((prev) => !prev)
            }}
          >
            <Icon icon="burger" />
          </Clickable>
          <div className={styles.menu}>
            <ul>
              {ITEMS.map(({ title, key, to, icon, highlight, hideSm }) => {
                if (isAppLayout && hideSm) {
                  return null
                }

                const isActive =
                  currentPathname === to ||
                  (currentPathname?.startsWith(to) && to !== "/")

                return (
                  <li
                    key={title}
                    className={classnames({
                      [styles.highlight]: highlight,
                      [styles.active]: isActive,
                    })}
                  >
                    <Clickable
                      {...(to?.startsWith("/")
                        ? { to }
                        : {
                            appNavTo: to,
                          })}
                      onClick={() => {
                        if (key === "apply") {
                          setApplyModalVisible(true)
                        }

                        setDropdownVisible(false)
                      }}
                    >
                      {title} <Icon icon={icon} />
                    </Clickable>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>

      <ApplyModal
        isOpen={applyModalVisible}
        onRequestClose={() => {
          setApplyModalVisible(false)
        }}
      />
    </nav>
  )
}

export default Nav
